import React from "react";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";


function StartAProject() {
  <main>
  <title>Start Your Web Design or SEO Project | Her Growth Co.</title>
<meta
name="description"
content="Ready to launch your website or boost your SEO? Let’s collaborate and build something impactful together."
/>
<meta
name="keywords"
content="start your visibility journey, work with a women-led agency, launch your brand online, digital strategy for female founders, begin your website transformation, get custom SEO support, request brand clarity consultation, elevate your online presence"
/>
</main>
  return (
    <div>
<NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
        Coming Soon
        </div>
        <Footer />
     
    </div>
  );
}

export default StartAProject